import React from 'react';

class TopicHeaderContent extends React.Component {
    render() {
        return (
            <div><h1 className="header-heading">{this.props.topicTitle}</h1>
                <div className="header-blue-line"></div>
                <div className="header-para">
                <p>
                    <em>{this.props.author.length > 0 ?
                        'By ' + this.props.author.join(' ; ')
                        : ''} in {this.props.bookTitle} </em>
                </p>
                
                <p dangerouslySetInnerHTML={{ __html: this.props.topContent !== null ? this.props.topContent : '' }}>
                </p>
                </div>
                </div>
        )
    }
}
export default TopicHeaderContent;